module.exports = __webpack_public_path__ + "img/icon.d1c298c6.svg";